import React, { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Hidden,
  MenuItem,
  Menu,
  Typography,
  Divider,
  Box,
} from "@mui/material";

import InputIcon from "@mui/icons-material/Input";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from "@mui/icons-material/People";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PollTwoToneIcon from "@mui/icons-material/PollTwoTone";
import { logout } from "../../logout";
import { useDispatch, useSelector } from "react-redux";
import Popup from "components/Popup";

function TopBar({ onOpenNavBarMobile }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState();

  const [anchorEl, setAnchorEl] = useState(null);
  const currentType = useSelector(
    (state) => state.currentTypeState.currentType
  );

  const openProfile = Boolean(anchorEl);
  const handleClick = (event) => {
    console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleClickOpen = (value) => {
    setOpen(true);
    setType(value);
  };

  const handleRouteRedirect = () => {
    if (currentType === "DEVICES") {
      return "/main/devices/Information";
    } else {
      return "/main/assemblies/Information";
    }
  };

  return (
    <AppBar
      sx={{ boxShadow: "none", position: "fixed", zIndex: 1201 }}
      color="primary"
    >
      <Toolbar>
        <IconButton
          sx={{ display: { md: "block", lg: "none" } }}
          color="inherit"
          onClick={onOpenNavBarMobile}
          size="large"
        >
          <MenuIcon />
        </IconButton>
        <Hidden smDown>
          <Typography
            variant="h4"
            component={RouterLink}
            to={handleRouteRedirect()}
            sx={{
              fontFamily: "Roboto",
              textDecoration: "none",
              color: "white",
              fontSize: "26px",
              letterSpacing: "1px",
              "&:hover": {
                color: "white",
              },
            }}
          >
            Manufacturing Tool Dashboard
          </Typography>
        </Hidden>
        {JSON.parse(localStorage.getItem("user")) &&
          JSON.parse(localStorage.getItem("user")).user.type === "MANAGER" && (
            <Hidden xsDown>
              <RouterLink to="/statistics/devices/Statistics">
                <div
                  style={{
                    marginLeft: "25%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <PollTwoToneIcon sx={{ fontSize: "40px", color: "white" }} />
                  <h1
                    style={{
                      fontFamily: "Roboto",
                      textDecoration: "none",
                      color: "white",
                      fontSize: "20px",
                      letterSpacing: "1px",
                    }}
                  >
                    Analytics
                  </h1>
                </div>
              </RouterLink>
            </Hidden>
          )}
        <Box sx={{ flexGrow: 1 }} />
        {location.pathname.includes("subjects") ? (
          <IconButton
            sx={{ display: { lg: "none" } }}
            color="inherit"
            size="large"
          >
            <PeopleIcon />
          </IconButton>
        ) : null}

        <Button
          sx={{ marginLeft: 1, color: "white" }}
          onClick={() => handleClickOpen(1)}
        >
          Firmware Update List
        </Button>

        <Popup type={type} open={open} setOpen={setOpen} />

        <Button
          id="profile-button"
          onClick={handleClick}
          color="inherit"
          aria-controls={openProfile ? "profile-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openProfile ? "true" : undefined}
        >
          <AccountBoxIcon />
          PROFILE
        </Button>

        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          slotProps={{
            paper: {
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateX(-50%) translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            },
          }}
        >
          <MenuItem onClick={handleClose}>
            {JSON.parse(localStorage.getItem("user")) ? (
              <div>
                <Typography variant="h5" color="text.secondary">
                  {JSON.parse(localStorage.getItem("user")).user.name +
                    " " +
                    JSON.parse(localStorage.getItem("user")).user.surname}
                </Typography>
                <Typography variant="body2">
                  {JSON.parse(localStorage.getItem("user")).user.type}
                </Typography>
              </div>
            ) : null}
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <InputIcon sx={{ mr: 1, color: "inherit" }} />
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
